import { ExecActState } from '@tencent/wphk-act-base-cgi';
import { i18n } from '../../i18n';
/** 自定义errName并export给外部（外部可能会用到） */
export var EXEC_FAIL_ERR_NAME;
(function (EXEC_FAIL_ERR_NAME) {
    /** 系统繁忙，可重试 */
    EXEC_FAIL_ERR_NAME["systemBusy"] = "ExecFailSystemBusy";
    /** 在黑名单 或 不在白名单*/
    EXEC_FAIL_ERR_NAME["block"] = "ExecFailBlock";
    /** 活动库存不足、个人库存不足。最新：频率限制（含自然人限制、机器限制等） */
    EXEC_FAIL_ERR_NAME["stockNotEnough"] = "ExecFailStockNotEnough";
    /**  用户没有资格（抽奖专用） 或 资格已使用（抽奖专用） */
    EXEC_FAIL_ERR_NAME["qualNotFulFilled"] = "ExecFailQualNotFulFilled";
    /** 资格数量不足（印花专用） */
    EXEC_FAIL_ERR_NAME["qualNotEnough"] = "ExecFailQualNotEnough";
    /** 失败状态之外的错误 */
    EXEC_FAIL_ERR_NAME["otherError"] = "ExecFailOtherError";
})(EXEC_FAIL_ERR_NAME || (EXEC_FAIL_ERR_NAME = {}));
;
/** ErrName对应的错误文案 */
const defaultFailInfoMap = {
    [EXEC_FAIL_ERR_NAME.systemBusy]: {
        message: i18n('当前领券人数较多，请稍后重试'),
        states: [ExecActState.fail, ExecActState.innerFail],
    },
    [EXEC_FAIL_ERR_NAME.block]: {
        message: i18n('您不符合活动参与条件，去「优惠专区」查看更多活动'),
        states: [ExecActState.block],
    },
    [EXEC_FAIL_ERR_NAME.stockNotEnough]: {
        message: i18n('当前账号或设备已达领取上限，去领取其他优惠吧'),
        states: [ExecActState.stockNotEnough],
    },
    [EXEC_FAIL_ERR_NAME.qualNotFulFilled]: {
        message: i18n('您暂时达到领取条件，快去完成任务再来领券吧'),
        states: [ExecActState.noQual, ExecActState.qualUsed],
    },
    [EXEC_FAIL_ERR_NAME.qualNotEnough]: {
        message: i18n('可兑换的印花数量不足，快去赚取印花吧'),
        states: [ExecActState.qualCountNotEnough],
    },
    [EXEC_FAIL_ERR_NAME.otherError]: {
        message: i18n('当前领券人数较多，请稍后重试'),
        states: [],
    },
};
// 自定义错误类
class ExecFailError extends Error {
    constructor(name, message, options) {
        super(message);
        /** 错误名 */
        this.name = 'UNKNOW';
        /** 错误信息 */
        this.message = '';
        /** 其他可携带的数据 */
        this.options = '';
        this.name = name;
        this.message = message;
        this.options = options || {};
    }
}
/**
 * 根据领券状态，throw具体的失败信息
 */
export function handleExecFail(execState) {
    // 查找execState对应的错误信息
    const errNameArr = Object.keys(defaultFailInfoMap);
    let findErrName = errNameArr.find(errName => defaultFailInfoMap[errName].states.includes(execState));
    findErrName = findErrName !== null && findErrName !== void 0 ? findErrName : EXEC_FAIL_ERR_NAME.otherError; // 如果没有从defaultFailInfoMap中找到（cgi返回预期之外的execState值），则默认otherError
    throw new ExecFailError(findErrName, defaultFailInfoMap[findErrName].message, { execState });
}
